module.exports = __webpack_public_path__ + "img/basket-black.22145e7b.svg";